import { initAcServices } from "AC/helpers/admin-columns";
import { getMetricConfig } from "./utils/inline-var";
import CalculationCell from "./components/CalculationCell.svelte";
const AcServices = initAcServices();
const metricsConfig = getMetricConfig();
AcServices.addListener("Table.Ready", (e) => {
    const table = e.table;
    const tableElement = table.getElement();
    const tfoot = tableElement.querySelector('tfoot');
    const originalRow = tfoot.querySelector('tr');
    const clonedRow = originalRow.cloneNode(true);
    clonedRow.querySelectorAll('th,td').forEach((cell) => {
        cell.innerHTML = '';
    });
    clonedRow.classList.add('acp-calculation-row');
    const metricMap = new Map(metricsConfig.columns.map(column => [column.id, column]));
    let hasMetricCells = false;
    table.Columns.getColumnNames().forEach((columnName) => {
        const metric = metricMap.get(columnName);
        if (!metric) {
            return;
        }
        const columnCell = clonedRow.querySelector('.column-' + columnName);
        if (!columnCell) {
            return;
        }
        columnCell.innerHTML = '';
        hasMetricCells = true;
        new CalculationCell({
            target: columnCell,
            props: {
                column: metric,
            }
        });
    });
    if (hasMetricCells && tfoot) {
        tfoot.prepend(clonedRow);
    }
});
